import { getHamiLayout } from '@/modules/hami/HamiLayout';
import { RouteChatsSkeleton } from '@/modules/hami/components/nativeChatsSkeleton';
import dynamic from 'next/dynamic';
import type { ComponentType } from 'react';

/**
 * A Next page for one messenger screen. The screen is client-only (the messenger reads window on
 * import) and gets its own chunk; while it loads, the same skeleton as the layout shows.
 */
export function hamiScreenPage(load: () => Promise<{ default: ComponentType }>) {
  // start downloading the screen with the page, not after the shell has rendered it
  if (typeof window !== 'undefined') load();
  const Screen = dynamic(load, { ssr: false, loading: () => <RouteChatsSkeleton /> });
  const Page = () => <Screen />;
  Page.getLayout = getHamiLayout;
  return Page;
}
